import { render, staticRenderFns } from "./RejectedOrders.vue?vue&type=template&id=344de22d&scoped=true&"
import script from "./RejectedOrders.vue?vue&type=script&lang=js&"
export * from "./RejectedOrders.vue?vue&type=script&lang=js&"
import style0 from "./RejectedOrders.vue?vue&type=style&index=0&id=344de22d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344de22d",
  null
  
)

export default component.exports